import React, { useState } from "react";
import "./Bot.css";
import AppImages from "../../Constants/AppImages";
import DashboardBottom from "./DashboardBootom";
import Account from "../Drawer/Account";
// Mock images - replace with your actual image paths
import TripManagement from "../Drawer/TripManagement";
import Menucard from "../MasterSettingOne/Menucard";
import CommunicationDrawer from "../Drawer/CommunicationDrawer";

// Mock components - replace with your actual components
// const TripManagement = ({ navigation }) => <div>Trip Management Component</div>;
// const DashboardBootom = ({ navigation }) => <div>Dashboard Component</div>;

const BottomTab = ({ navigation }) => {
  const [tabIndex, setTabIndex] = useState(2);

  const renderContent = () => {
    switch (tabIndex) {
      case 0:
        return <Account navigation={navigation} />;
      case 1:
        return <TripManagement navigation={navigation} />;
      case 2:
        return <DashboardBottom navigation={navigation} />;
      case 3:
        return <Menucard navigation={navigation} />;
      case 4:
        return <CommunicationDrawer navigation={navigation} />;
      default:
        return <DashboardBottom navigation={navigation} />;
    }
  };

  return (
    <div className="bottom-tab-container">
      <div className="content-area">{renderContent()}</div>

      <div className="bottom-tab-bar">
        {/* Account Tab */}
        <div
          className={`tab-item ${tabIndex === 0 ? "active" : ""}`}
          onClick={() => setTabIndex(0)}
        >
          <div className="tab-icon">
            <img
              src={
                tabIndex === 0
                  ? AppImages.BottomAccontActive
                  : AppImages.ProfileBottom
              }
              alt="Account"
              className="tab-image"
            />
          </div>
        </div>

        {/* Trips Tab */}
        <div
          className={`tab-item ${tabIndex === 1 ? "active" : ""}`}
          onClick={() => setTabIndex(1)}
        >
          <div className="tab-icon">
            <img
              src={
                tabIndex === 1
                  ? AppImages.BottomTripActive
                  : AppImages.TripBottom
              }
              alt="Trips"
              className="tab-image"
            />
          </div>
        </div>

        {/* Center Dashboard Tab */}
        <div className="tab-center-item" onClick={() => setTabIndex(2)}>
          <div className="center-button">
            <img
              src={
                tabIndex === 2
                  ? AppImages.BottomDashboard
                  : AppImages.BottomDashboardInactive
              }
              alt="Dashboard"
              className="center-image"
            />
          </div>
        </div>

        {/* Settings Tab */}
        <div
          className={`tab-item ${tabIndex === 3 ? "active" : ""}`}
          onClick={() => setTabIndex(3)}
        >
          <div className="tab-icon">
            <img
              src={
                tabIndex === 3
                  ? AppImages.BottomMastersettingActive
                  : AppImages.BottomSetting
              }
              alt="Settings"
              className="tab-image"
            />
          </div>
        </div>

        {/* Messages Tab */}
        <div
          className={`tab-item ${tabIndex === 4 ? "active" : ""}`}
          onClick={() => setTabIndex(4)}
        >
          <div className="tab-icon">
            <img
              src={
                tabIndex === 4
                  ? AppImages.BottomCommunicationActive
                  : AppImages.MessageBottom
              }
              alt="Messages"
              className="tab-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomTab;
